import { getConfig } from '../utilities';

const useMenuView = async() => {

  let configParams = await getConfig(localStorage.getItem('path'))
  return configParams;
}

export default useMenuView;